import { supabase } from '../../lib/supabaseClient';

const EPISODES_BUCKET = 'Episodes';
const IMAGES_BUCKET = 'Images';

const extractStoragePath = (raw?: string | null, bucket?: string): string | null => {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (!trimmed.startsWith('http')) {
    return trimmed.replace(/^\/+/, '');
  }
  if (!bucket) return null;
  const bucketSegment = `/${bucket}/`;
  const bucketIndex = trimmed.indexOf(bucketSegment);
  if (bucketIndex === -1) return null;
  const withoutParams = trimmed.slice(bucketIndex + bucketSegment.length).split('?')[0];
  return decodeURIComponent(withoutParams);
};

export const extractEpisodeStoragePath = (raw?: string | null): string | null =>
  extractStoragePath(raw, EPISODES_BUCKET);

export const extractImageStoragePath = (raw?: string | null): string | null =>
  extractStoragePath(raw, IMAGES_BUCKET);

export const getPlayableEpisodeUrl = async (raw?: string | null): Promise<string | null> => {
  if (!raw) return null;
  const storagePath = extractEpisodeStoragePath(raw);
  if (!storagePath) return raw;
  const { data, error } = await supabase.storage
    .from(EPISODES_BUCKET)
    .createSignedUrl(storagePath, 60 * 60 * 24 * 7);
  if (error || !data?.signedUrl) {
    console.error('Unable to generate signed URL for episode audio', error);
    // If the raw path is not an absolute URL, avoid using it to prevent invalid media URIs.
    return raw.startsWith('http') ? raw : null;
  }
  return data.signedUrl;
};

export const getDisplayImageUrl = async (raw?: string | null): Promise<string | null> => {
  if (!raw) return null;
  const storagePath = extractImageStoragePath(raw);
  if (!storagePath) return raw;
  const { data, error } = await supabase.storage
    .from(IMAGES_BUCKET)
    .createSignedUrl(storagePath, 60 * 60 * 24 * 7);
  if (error || !data?.signedUrl) {
    console.error('Unable to generate signed URL for image', error);
    return raw;
  }
  return data.signedUrl;
};

export const MEDIA_CONSTANTS = {
  EPISODES_BUCKET,
  IMAGES_BUCKET,
};
